const openButton = document.querySelector('.katalog-iframe__text');
const closeButton = document.querySelector('.katalog-iframe__close-btn');

if (openButton && closeButton) {
    openButton.addEventListener('click', () => {
        document.body.classList.add('-open');
    });

    closeButton.addEventListener('click', () => {
        document.body.classList.remove('-open');
    });
}